var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#47d147"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.861 7.13203C14.0463 7.30806 14.0463 7.59324 13.861 7.76928L8.49363 12.868C8.40097 12.956 8.27959 13 8.15821 13C8.03683 13 7.91545 12.956 7.82279 12.868L5.13899 10.3187C4.95367 10.1427 4.95367 9.85752 5.13899 9.68148C5.3243 9.50545 5.62451 9.50545 5.80982 9.68148L8.15821 11.9121L13.1902 7.13203C13.3755 6.95599 13.6757 6.95599 13.861 7.13203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.c3d82a265dc733578140354e3a73bc5d.svg";
export { ForwardRef as ReactComponent };